import pdpSlider from "./rbmc.pdp-slider";
import pdpCustomPersonalization from "./rbmc.pdp-custom-personalization";
import pdpPlayerPersonalization from "./rbmc.pdp-player-personalization";
import productDetails from "./rbmc.pdp";

const pdpConfig = {
    configuratorWrapper:    undefined,
    personNameNumber:       undefined,
    personalizeImage:       undefined,
    personalizeMobileImage: undefined,
    personalizationPanel:   undefined,
    personalizationControl: undefined,
    savePersonalization:    undefined,
    customPatchField:       undefined,
    configurationArea:      undefined,
    sliderArea:             undefined,
    customImageWrapper:     undefined,
    sliderReload:           "",
    originalImageSrc:       "",
    customNameFlag:         false,
    playerChosenFlag:       false,
    firstTimePersonalized:  true,

    loadDefaults() {
        pdpConfig.personNameNumber.html(
                pdpConfig.personNameNumber.data('default')
        );

        pdpConfig.customPatchField.html(
                pdpConfig.customPatchField.data('default')
        );
        $('#pdp__select-option').selectpicker({
            dropupAuto: false
        });
    },

    bindEvents() {
        // action on icon reset click for pdpCustomPersonalization
        pdpConfig.personalizationControl.on('click', '.pdp__icon-reset',
                pdpCustomPersonalization.resetNameAndNumberChoice
        );

        pdpPlayerPersonalization.selectPlayerOptionWrapper.on('click', '.pdp__icon-reset',
                pdpPlayerPersonalization.resetPdpPlayerSelectChoice
        );

        //action on personalizationControl click
        pdpConfig.personalizationControl.on('click', function () {
            pdpSlider.goToPersonalizedSlide();
            pdpConfig.openPersonalizationPanel();
            productDetails.menuOpened = true;
        });

        //reset whole presonalization entries
        $('#pdp__reset-all-personalization').on('click', pdpConfig.resetWholeCustomizationForm);

        //just close configurator on mobile phones
        $('#pdp__confirm-personalization').on('click', pdpConfig.closeMobileConfigurator);

        pdpConfig.configurationArea.on('click', '.pdp__icon-close', pdpConfig.closeMobileConfigurator);
    },

    closePersonalizationPanel(isSave = false) {
        if (productDetails.mobileActiveFlag) {
            pdpConfig.personalizationPanel.removeClass('panelAnimate');
            setTimeout(function () {
                pdpConfig.personalizationPanel.addClass('d-none');
            }, 500);
        } else {
            pdpConfig.personalizationPanel.addClass('d-none');
        }
        pdpCustomPersonalization.persName.tooltip("hide");
        pdpCustomPersonalization.persNumber.tooltip("hide");
        pdpConfig.configuratorWrapper.removeClass('d-none');
        productDetails.menuOpened = false;
    },

    openPersonalizationPanel() {
        if (productDetails.mobileActiveFlag) {
            pdpConfig.personalizationPanel.removeClass('d-none');

            setTimeout(function () {
                pdpConfig.personalizationPanel.addClass('panelAnimate');
            }, 50);

            setTimeout(function () {
                pdpConfig.configuratorWrapper.addClass('d-none');
            }, 550);
        } else {
            pdpConfig.personalizationPanel.addClass('panelAnimate');
            pdpConfig.personalizationPanel.removeClass('d-none');
            pdpConfig.configuratorWrapper.addClass('d-none');
        }
    },

    restoreOriginalImageSrc() {
        pdpConfig.sliderArea.removeClass(pdpConfig.sliderReload);
        pdpConfig.customImageWrapper.removeClass(pdpConfig.sliderReload);
        pdpConfig.personalizeImage.attr("src", pdpConfig.originalImageSrc);
        pdpConfig.personalizeMobileImage.attr("src", pdpConfig.originalImageSrc);
    },

    loadEventControl(evt) {
        const $target = $(evt.currentTarget);
        if ($target.hasClass('pdp__personalize-image')) {
            const validSlide = !$target.parents('.slick-slide')
                                       .hasClass('slick-cloned');
            if (validSlide) {
                pdpConfig.sliderArea.removeClass(pdpConfig.sliderReload);
                pdpConfig.customImageWrapper.removeClass(pdpConfig.sliderReload);
            }
        }
    },

    setCustomizedImageUrl(elemArray, url, name, number) {
        pdpConfig.sliderArea.addClass(pdpConfig.sliderReload);
        pdpConfig.customImageWrapper.addClass(pdpConfig.sliderReload);

        $.each(elemArray, function (i, elem) {
            elem.attr(pdpConfig.firstTimePersonalized ? 'data-lazy' : 'src',
                    url.data("url")
                       .replace("[[NAME]]", name)
                       .replace("[[00]]", number)
            );
        });
    },

    closeMobileConfigurator(event) {
        if (event !== undefined) {
            event.stopImmediatePropagation();
        }
        productDetails.configurationArea.removeClass('pdp__configurator-open');
    },

    resetWholeCustomizationForm() {
        productDetails.configurationArea.find(".pdp__icon-reset").click();
    },

    initDefaults() {
        pdpConfig.configuratorWrapper    = $('.pdp__configurator-wrapper');
        pdpConfig.personNameNumber       = $('#pdp__personalization-name-number');
        pdpConfig.personalizeImage       = $('.pdp__personalize-image');
        pdpConfig.personalizeMobileImage = $('.pdp__mobile-custom-image');
        pdpConfig.personalizationPanel   = $('#pdp__personalization-panel');
        pdpConfig.personalizationControl = $('#pdp__personalization-control');
        pdpConfig.savePersonalization    = $('#pdp__save-personalization');
        pdpConfig.customPatchField       = $('#pdp__sponsor-patch');
        pdpConfig.configurationArea      = $("#pdp__configuration-area");
        pdpConfig.sliderArea             = $('.pdp__slider-area');
        pdpConfig.customImageWrapper     = $('.pdp__mobile-custom-image-wrapper');
        pdpConfig.sliderReload           = 'pdp__slider--reload';

        if (pdpConfig.personalizeImage.data('lazy')) {
            pdpConfig.originalImageSrc = pdpConfig.personalizeImage.data('lazy');
        } else {
            pdpConfig.originalImageSrc = pdpConfig.personalizeImage.attr('src');
        }
        pdpConfig.personalizeImage.on('load', pdpConfig.loadEventControl);
        pdpConfig.personalizeMobileImage.on('load', pdpConfig.loadEventControl);
    },

    init() {
        pdpConfig.initDefaults();
        pdpConfig.loadDefaults();
        pdpConfig.bindEvents();
    }
};

export default pdpConfig;
